<!-- Backdrop -->
<div *ngIf="is_open" class="fixed inset-0 bg-black/20 z-40" (click)="on_close()"></div>

<!-- Messenger Panel -->
<div *ngIf="is_open" class="fixed top-2 right-2 h-[98%] w-[420px] bg-white shadow-[0px_25px_50px_rgba(0,0,0,0.25)] z-50 flex flex-col rounded-[14px] overflow-hidden">

  <!-- ===== CONVERSATION LIST VIEW ===== -->
  <ng-container *ngIf="view === 'list'">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-5 shrink-0">
      <div class="flex-1">
        <!-- <button (click)="on_close()" class="flex items-center gap-2 text-[#101828] hover:opacity-70 transition-opacity">
          <i class="bx bx-undo"></i>
          <span class="text-sm font-medium capitalize">Back</span>
        </button> -->
      </div>
      <h2 class="flex-1 text-center text-xl font-medium text-[#101828] capitalize">Messages</h2>
      <div class="flex-1 flex justify-end">
        <button (click)="on_close()" class="text-gray-400 hover:text-gray-600 transition-colors">
          <span class="material-icons text-xl">close</span>
        </button>
      </div>
    </div>

    <!-- Subject + Recipient Dropdowns -->
    <div class="px-6 pb-3 space-y-3 shrink-0">
      <div class="relative">
        <label class="text-xs text-gray-500 mb-1 block">Subject</label>
        <ng-select [items]="subjects" bindLabel="name" placeholder="Select Subject" [(ngModel)]="selected_subject" [clearable]="true" [searchable]="true" [loading]="loading_subjects" (change)="on_subject_change($event)" class="messenger-select"></ng-select>
      </div>

      <div *ngIf="selected_subject" class="flex gap-2 items-end">
        <div class="flex-1">
          <label class="text-xs text-gray-500 mb-1 block">
            {{ gs.user_data?.Role?.name === 'Evaluator' ? 'Head Evaluator' : 'Evaluator' }}
          </label>
          <ng-select [items]="recipients" bindLabel="name" [placeholder]="'Search ' + (gs.user_data?.Role?.name === 'Evaluator' ? 'Head Evaluator' : 'Evaluator')" [(ngModel)]="selected_recipient" [clearable]="true" [searchable]="true" [loading]="loading_recipients" class="messenger-select">
            <ng-template ng-option-tmp let-item="item">
              <span>{{ item.name }}</span>
              <span *ngIf="item.Role?.name" class="ml-1 text-xs text-gray-400">({{ item.Role.name }})</span>
            </ng-template>
          </ng-select>
        </div>
        <button (click)="open_chat_from_dropdowns()" [disabled]="!selected_recipient" class="w-10 h-10 rounded-full bg-[#3F41D1] text-white flex items-center justify-center disabled:opacity-40 hover:bg-indigo-700 transition-colors shrink-0">
          <i class="bx bx-send-alt"></i>
        </button>
      </div>

      <div *ngIf="!loading_subjects && subjects.length === 0" class="text-sm text-gray-400 text-center py-2">
        No subjects available
      </div>
      <div *ngIf="selected_subject && !loading_recipients && recipients.length === 0" class="text-sm text-gray-400 text-center py-1">
        No recipients available for this subject
      </div>
    </div>

    <!-- Conversation List -->
    <div class="flex-1 overflow-y-auto px-4 pb-4">
      <div *ngIf="loading_conversations" class="flex justify-center py-8">
        <div class="w-6 h-6 border-2 border-[#3F41D1] border-t-transparent rounded-full animate-spin"></div>
      </div>

      <ng-container *ngIf="!loading_conversations">
        <ng-container *ngIf="conversations.length === 0">
          <div class="text-center text-gray-400 text-sm py-12">
            <span class="material-icons text-4xl text-gray-200 block mb-2">chat_bubble_outline</span>
            No conversations yet
          </div>
        </ng-container>

        <ng-container *ngFor="let group of grouped_conversations; trackBy: track_by_group">
          <!-- Date separator -->
          <div class="flex justify-center my-3">
            <span class="backdrop-blur-sm bg-[rgba(33,33,33,0.1)] text-[#a3a3a3] text-xs px-3 py-1 rounded-[64px]">{{ group.label }}</span>
          </div>

          <div *ngFor="let convo of group.items; trackBy: track_by_convo" (click)="open_chat_from_list(convo)" [ngClass]="{'bg-blue-50': convo.unread_count > 0}" class="flex items-center gap-3 px-3 py-3 rounded-2xl cursor-pointer hover:bg-gray-50 transition-all mb-1">
            <div class="w-10 h-10 rounded-full bg-[#3F41D1] text-white flex items-center justify-center text-sm font-semibold shrink-0">
              {{ get_initials(convo.other_user?.name) }}
            </div>
            <div class="flex-1 min-w-0">
              <div class="flex justify-between items-center mb-0.5">
                <span class="text-sm font-semibold text-[#101828] truncate">
                  {{ convo.other_user?.name }}
                  <span *ngIf="convo.other_user?.Role?.name" class="text-xs text-[#a3a3a3] font-normal ml-1">({{ convo.other_user?.Role?.name }})</span>
                </span>
                <span class="text-[10px] text-[#a3a3a3] shrink-0 ml-2">{{ format_time(convo.last_message_at) }}</span>
              </div>
              <div class="flex justify-between items-center">
                <p class="text-xs text-[#a3a3a3] truncate mr-2">{{ convo.last_message }}</p>
                <div *ngIf="convo.unread_count > 0" class="bg-[#3F41D1] text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full shrink-0">
                  {{ convo.unread_count }}
                </div>
              </div>
            </div>
            <span class="material-icons text-gray-300 text-base shrink-0">chevron_right</span>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <!-- ===== CHAT VIEW ===== -->
  <ng-container *ngIf="view === 'chat'">
    <!-- Chat Header -->
    <div class="flex items-center justify-between px-6 py-5 h-[68px] shrink-0">
      <div class="flex-1">
        <button (click)="go_back()" class="flex items-center gap-2 text-[#101828] hover:opacity-70 transition-opacity">
          <i class="bx bx-undo"></i>
          <span class="text-sm font-medium capitalize">Back</span>
        </button>
      </div>
      <div class="flex-1 flex justify-center">
        <p class="text-xl font-medium text-[#101828] capitalize">Messages</p>
      </div>
      <div class="flex-1 flex justify-end">
        <button (click)="on_close()" class="text-gray-400 hover:text-gray-600 transition-colors">
          <span class="material-icons text-xl">close</span>
        </button>
      </div>
    </div>

    <!-- Messages Area -->
    <div id="chat-messages-container" class="flex-1 overflow-y-auto flex flex-col gap-4 px-6 pb-4">
      <div *ngIf="loading_messages" class="flex justify-center py-8">
        <div class="w-6 h-6 border-2 border-[#3F41D1] border-t-transparent rounded-full animate-spin"></div>
      </div>

      <ng-container *ngIf="!loading_messages">
        <div *ngIf="messages.length === 0" class="text-center text-gray-400 text-sm py-12">
          <span class="material-icons text-4xl text-gray-200 block mb-2">chat</span>
          No messages yet. Start the conversation!
        </div>

        <ng-container *ngFor="let group of group_messages_by_date()">
          <!-- Date separator -->
          <div class="flex justify-center shrink-0">
            <span class="backdrop-blur-sm bg-[rgba(33,33,33,0.1)] text-[#a3a3a3] text-xs px-3 py-1 rounded-[64px]">{{ group.label }}</span>
          </div>

          <ng-container *ngFor="let msg of group.items">
            <!-- Sent (mine) -->
            <div *ngIf="is_my_message(msg)" class="flex justify-end pl-10 shrink-0">
              <div class="bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.3),0px_2px_6px_rgba(0,0,0,0.15)] rounded-2xl px-4 py-3 flex gap-2 items-end max-w-[360px]">
                <p class="flex-1 text-[#1e1e1e] text-sm leading-[18px]">{{ msg.message_text }}</p>
                <span class="text-[#a3a3a3] text-xs whitespace-nowrap shrink-0">{{ format_time(msg.createdAt) }}</span>
              </div>
            </div>

            <!-- Received -->
            <div *ngIf="!is_my_message(msg)" class="flex items-start gap-2 pr-7 shrink-0">
              <div class="bg-[#3F41D1] w-[21px] min-w-[21px] h-[21px] rounded-full flex items-center justify-center text-white text-[11px] font-medium uppercase shrink-0">
                {{ get_initials(msg.Sender?.name).charAt(0) }}
              </div>
              <div class="bg-[#3F41D1] rounded-2xl px-4 py-3 flex gap-2 items-end">
                <p class="text-white text-sm leading-[18px]">{{ msg.message_text }}</p>
                <span class="text-white text-[12px] leading-none font-normal whitespace-nowrap shrink-0">{{ format_time(msg.createdAt) }}</span>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <!-- Message Input -->
    <div class="px-6 pb-6 shrink-0">
      <div class="bg-white rounded-2xl shadow-[0px_1px_2px_rgba(0,0,0,0.3),0px_1px_3px_1px_rgba(0,0,0,0.15)] min-h-[95px] flex gap-3 items-end pl-4 pr-3 py-4">
        <textarea [(ngModel)]="message_text" (keydown)="on_enter($event)" (input)="strip_numbers($event)" placeholder="Start Typing...." rows="1" class="flex-1 bg-transparent text-sm text-[#1e1e1e] placeholder-[#a3a3a3] resize-none outline-none min-h-16 leading-5" style="field-sizing: content;"></textarea>
        <button (click)="send()" [disabled]="!message_text.trim() || sending" class="w-[25px] h-[25px] flex items-center justify-center text-[#3F41D1] disabled:opacity-40 hover:opacity-70 transition-opacity shrink-0">
          <i *ngIf="!sending" class="bx bx-send-alt text-xl"></i>
          <div *ngIf="sending" class="w-4 h-4 border-2 border-[#3F41D1] border-t-transparent rounded-full animate-spin"></div>
        </button>
      </div>
    </div>
  </ng-container>
</div>